
class DBImportColumnHeader extends MUIView 
{
    columnFilterTextField:ColumnFilterTextField = null;
    private sortButton:MUIButton = null;
    private keyDropdownButton:MUIButton = null;

    private _availableKeys:string[] = [];
    private _selectedKey:string = null;
    private _excelColumnIndex:number = -1;

    awakeFromHTML(){
        this.columnFilterTextField = MUIOutlet(this, "search-column", "ColumnFilterTextField");
        this.sortButton = MUIOutlet(this, "sort-btn", "MUIButton");
        if (this.sortButton != null) this.sortButton.setAction(this, this.sortButtonDidClick);

        this.keyDropdownButton = MUIOutlet(this, "key-dropdown-btn", "MUIButton");
        if (this.keyDropdownButton != null) this.keyDropdownButton.setAction(this, this.showKeySelectionAlert);
    }

    set title(value:string){
        if (this.columnFilterTextField != null) this.columnFilterTextField.placeholderText = MIOLocalizeString(value.toUpperCase(), value);
    }

    set excelColumnIndex(value:number) {
        this._excelColumnIndex = value;
    }

    get excelColumnIndex():number {
        return this._excelColumnIndex;
    }

    set availableKeys(keys:string[]) {
        this._availableKeys = keys;
    }

    get availableKeys():string[] {
        return this._availableKeys;
    }

    set selectedKey(key:string) {
        this._selectedKey = key;
        if (this.keyDropdownButton != null) {
            this.keyDropdownButton.title = key != null ? MIOLocalizeString(key, key) : MIOLocalizeString("SELECT_KEY", "Select Key");
        }
    }

    get selectedKey():string {
        return this._selectedKey;
    }

    private action = null;
    private target = null;
    private column:MUIReportTableViewColumn = null;
    setAction(target, action, column:MUIReportTableViewColumn){
        this.target = target;
        this.action = action;
        this.column = column;
    }

    private keySelectionTarget = null;
    private keySelectionAction = null;
    setKeySelectionAction(target, action) {
        this.keySelectionTarget = target;
        this.keySelectionAction = action;
    }

    private sortButtonDidClick(){
        if (this.action == null || this.target == null) return;

        MUICoreLayerRemoveStyle(this.sortButton.layer, "order-sort");
        MUICoreLayerRemoveStyle(this.sortButton.layer, "order-sort-asc");
        MUICoreLayerRemoveStyle(this.sortButton.layer, "order-sort-desc");

        if (this.column.ascending == true) {
            MUICoreLayerAddStyle(this.sortButton.layer, "order-sort-asc");
        }
        else if (this.column.ascending == false) {
            MUICoreLayerAddStyle(this.sortButton.layer, "order-sort-desc");
        }

        this.action.call(this.target, this.column);
    }

    private showKeySelectionAlert() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(
            MIOLocalizeString("SELECT_DB_KEY", "Select DB Key"),
            MIOLocalizeString("SELECT_FIELD_FOR_COLUMN", "Select the field to map this column to"),
            MUIAlertViewStyle.Default
        );

        // Add "No Selection" option
        avc.addAction(MUIAlertAction.alertActionWithTitle(
            MIOLocalizeString("NO_SELECTION", "-- No Selection --"),
            MUIAlertActionStyle.Default,
            this,
            function(this:DBImportColumnHeader) {
                this.selectedKey = null;
                this.notifyKeySelectionChange();
            }
        ));

        // Add all available keys using closure to capture the key properly
        for (let i = 0; i < this._availableKeys.length; i++) {
            let key = this._availableKeys[i];
            this.addKeyAction(avc, key);
        }

        avc.addAction(MUIAlertAction.alertActionWithTitle(
            MIOLocalizeString('CANCEL', 'CANCEL'),
            MUIAlertActionStyle.Cancel,
            null,
            null
        ));

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.window.rootViewController.presentViewController(avc, true);
    }

    private addKeyAction(avc:MUIAlertViewController, key:string) {
        avc.addAction(MUIAlertAction.alertActionWithTitle(
            MIOLocalizeString(key, key),
            MUIAlertActionStyle.Default,
            this,
            function(this:DBImportColumnHeader) {
                this.selectedKey = key;
                this.notifyKeySelectionChange();
            }
        ));
    }

    private notifyKeySelectionChange() {
        if (this.keySelectionAction != null && this.keySelectionTarget != null) {
            this.keySelectionAction.call(this.keySelectionTarget, this, this._excelColumnIndex, this._selectedKey);
        }
    }
}

